class EditBranchForm {
    constructor() {
        this.branchID = null;
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.fv = null;
        this.editBranch();
    }
    editBranch(){
        const thisClass = this;
        $(document).on('click', '.edit-branch', function(e) {
            thisClass.branchID = $(this).parent()[0].id;
            thisClass.show();
        });
    }
    show(){
        const thisClass = this;

        new ModalLoading();
        naja.makeRequest('GET', '/branches/?do=getBranchDetails', {
            'branchID': this.branchID,
            'organizationID': this.organizationID
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response) {
                let editBranchModal = document.getElementById('edit_branch_modal');
                this.initDeleteBranch(editBranchModal);

                new bootstrap.Modal(editBranchModal, {}).show();
                $('#frm-generalForms-editBranchForm-branchForm select').select2({
                    dropdownParent: $('#edit_branch_modal')
                });
                $("#frm-generalForms-editBranchForm-branchForm  select[name=pseudo_random_function]").select2({
                    placeholder: "-- select pseudo-random function --",
                    dropdownParent: $('#edit_branch_modal'),
                    allowClear: true
                });

                $("#frm-generalForms-editBranchForm-branchForm  select[name=start_action]").select2({
                    placeholder: "",
                    dropdownParent: $('#edit_branch_modal'),
                    allowClear: true
                });
                thisClass.events();

                this.hideGeneralModals(editBranchModal);
                new ModalLoading(editBranchModal);
            }
        }).catch(error => {
            new ModalLoading();
            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
        });
    }
    initDeleteBranch(editBranchModal){
        const deleteBranchButton = editBranchModal.querySelector('.delete-branch');
        if(deleteBranchButton){
            deleteBranchButton.addEventListener('click', function () {
                let customZoneForwarding = this.getAttribute('data-custom-zone-forwarding');
                let branchID = deleteBranchButton.parentNode.id;
                new Branch(branchID).remove(undefined, customZoneForwarding);
            });
        }
    }
    hideGeneralModals(editBranchModal){
        let editAccessCardModal = document.getElementById('edit_access_card_modal');
        if(editAccessCardModal && editAccessCardModal.classList.contains('show')) {
            bootstrap.Modal.getInstance(editAccessCardModal).hide();
            new AddBackLinkToModal(editAccessCardModal, editBranchModal);
        }
        let createAccessCardModal = document.getElementById('create_access_card_modal');
        if(createAccessCardModal && createAccessCardModal.classList.contains('show')) {
            bootstrap.Modal.getInstance(createAccessCardModal).hide();
            new AddBackLinkToModal(createAccessCardModal, editBranchModal);
        }
    }
    events(){
        this.testConnection();
        this.startConnection();
        this.preselectSelect();
        this.validation();

        this.changeName();
        this.configurationGuide();
        this.branchSegments();
        this.changeAvatar();
        this.changeSubnet();
        this.backToEditBranch();
    }
    backToEditBranch(){
        $(document).on('click', '.back-to-edit-branch', function(e) {
            let modalID = $(this).closest('.modal.fade.show')[0].attributes.id.value;
            bootstrap.Modal.getInstance(document.getElementById(modalID)).hide();
            new bootstrap.Modal(document.getElementById('edit_branch_modal'), {}).show();
        });
    }
    configurationGuide(){
        const thisClass = this;
        $('#edit-branch-configuration').click(function (){
            $(this).find('.menu-title').after('<span class="menu-spinner spinner-border spinner-border-sm align-middle ms-2"></span>');

            new IkevConfigurationGuide(thisClass.branchID).show($('#edit_branch_modal'));
        });
    }
    branchSegments(){
        const thisClass = this;
        $('#edit-branch-segments').click(function (){
            bootstrap.Modal.getOrCreateInstance(document.getElementById('edit_branch_modal')).hide();
            new BranchSegmentsDatatable(thisClass.branchID);
            bootstrap.Modal.getOrCreateInstance(document.getElementById('branch_segments_modal')).show();
        });
    }
    changeName(){
        const constFv = this.fv;
        $('#edit-branch-name-button').click(function () {
            $('#edit-branch-name-section').addClass('d-none');
            $('#frm-generalForms-editBranchForm-branchForm input[name=BranchName]').removeClass('d-none');
            constFv.enableValidator('BranchName');
        });
    }
    changeAvatar(){
        $('.edit-branch-icon-btn').click(function (){
            new bootstrap.Modal(document.getElementById('change_branch_icon_modal'), {}).show();
            $('.branch-select-icon').click(function () {
                let val = $(this).attr('value');
                $('#edit-branch-icon').attr('src','/media/goodaccess/icons/branch/'+val+'.svg');
                $('#change_branch_icon_modal').modal('hide');
                $('#frm-generalForms-editBranchForm-branchForm input[name=icon_id]').val(val);
            });
        });
    }
    changeSubnet(){
        const constFv = this.fv;
        $('#edit-branch-subnet-button').click(function () {
            let subnetInput = $('#frm-generalForms-editBranchForm-branchForm input[name=BranchSubnet]');
            let subnetValue = subnetInput.val();
            let changeSubnetAlert = $('#change-subnet-alert');
            $('#edit-branch-subnet-section').addClass('d-none');
            subnetInput.removeClass('d-none');
            constFv.enableValidator('BranchSubnet');

            if(changeSubnetAlert){
                let timer = 0;
                subnetInput.on('input', function () {
                    let currentValue = $(this).val();
                    // Reset the timer
                    clearTimeout(timer);
                    timer = setTimeout(function() {
                       if(currentValue !== subnetValue){
                           changeSubnetAlert.removeClass('d-none');
                       } else {
                           changeSubnetAlert.addClass('d-none');
                       }
                    }, 500);
                });
            }
        });
    }
    testConnection(){
        const thisClass = this;
        $('#branch-test-connection').click(function (e){
            const thisElement = this;
            $(this).find('.spinner-border').removeClass('d-none');
            $.ajax({
                url: '/branches/?do=testConnection',
                type: 'GET',
                dataType: '',
                data: {branchID: thisClass.branchID}
            }).done(function(data) {
                let branchStatus    = $('#branch-status');
                $(thisElement).find('.spinner-border').addClass('d-none');
                branchStatus.removeClass('text-danger');
                branchStatus.removeClass('text-success');
                if(data['is_connected']){
                    $('#branch-start-connection').addClass('d-none');
                    toastr.success('Connection test has been successful. Cloud/branch "'+data['name']+'" is currently connected to Gateway.');
                }else{
                    $('#branch-start-connection').removeClass('d-none');
                    toastr.error('Connection test has not been successful. Cloud/branch "'+data['name']+'" is currently disconnected from Gateway.');
                }
                $('#last_test_datetime').text(data['connection_datetime']);

                if(data['is_connected']){
                    $('#branch-start-connection').hide();
                    branchStatus.text('Connected');
                    branchStatus.addClass('text-success');
                }else{
                    $('#branch-start-connection').show();
                    branchStatus.text('Disconnected');
                    branchStatus.addClass('text-danger');
                }
            });
        });
    }
    startConnection(){
        const thisClass = this;
        $('#branch-start-connection').click(function (e){
            const thisElement = this;
            $(this).find('.spinner-border').removeClass('d-none');
            $.ajax({
                url: '/branches/?do=startConnection',
                type: 'GET',
                dataType: '',
                data: {branchID: thisClass.branchID}
            }).done(function(data) {
                let branchStatus    = $('#branch-status');
                $(thisElement).find('.spinner-border').addClass('d-none');
                branchStatus.removeClass('text-danger');
                branchStatus.removeClass('text-success');
                if(data['is_connected']){
                    $('#branch-start-connection').addClass('d-none');
                    toastr.success('Connection test has been successfully. Cloud/branch "'+data['name']+'" is currently connected to Gateway.');
                }else{
                    $('#branch-start-connection').removeClass('d-none');
                    toastr.error('Connection test has not been successful. Cloud/branch "'+data['name']+'" is currently disconnected from Gateway.');
                }

                if(data['status'] === 'warning'){
                    toastr.warning(data['message']);
                }

                $('#last_test_datetime').text(data['connection_datetime']);

                if(data['is_connected']){
                    $('#branch-start-connection').hide();
                    branchStatus.text('Connected');
                    branchStatus.addClass('text-success');
                }else{
                    $('#branch-start-connection').show();
                    branchStatus.text('Disconnected');
                    branchStatus.addClass('text-danger');
                }
            });
        });
    }
    preselectSelect(){
        $('#frm-generalForms-editBranchForm-branchForm select[name=presetSelect]').change(function (e){
            let preset = $(e.target).find(":selected");
            $('#frm-generalForms-editBranchForm-branchForm input[name=tunnel_lifetime]').val(preset.attr('tunnel-lifetime'));
            $('#frm-generalForms-editBranchForm-branchForm input[name=ike_lifetime]').val(preset.attr('ike-lifetime'));
            $('#frm-generalForms-editBranchForm-branchForm input[name=dpdd]').val(preset.attr('dead-peer-detection-delay'));
            $('#frm-generalForms-editBranchForm-branchForm select[name=encryption_phase_1]').val(preset.attr('encryption-phase-1')).trigger('change');
            $('#frm-generalForms-editBranchForm-branchForm select[name=encryption_phase_2]').val(preset.attr('encryption-phase-2')).trigger('change');
            $('#frm-generalForms-editBranchForm-branchForm select[name=integrity_phase_1]').val(preset.attr('integrity-phase-1')).trigger('change');
            $('#frm-generalForms-editBranchForm-branchForm select[name=integrity_phase_2]').val(preset.attr('integrity-phase-2')).trigger('change');
            $('#frm-generalForms-editBranchForm-branchForm select[name=dh_phase_1]').val(preset.attr('dh-groups-phase-1')).trigger('change');
            $('#frm-generalForms-editBranchForm-branchForm select[name=dh_phase_2]').val(preset.attr('dh-groups-phase-2')).trigger('change');
            $('#frm-generalForms-editBranchForm-branchForm select[name=start_action]').val(preset.attr('start-action')).trigger('change');
            $('#frm-generalForms-editBranchForm-branchForm select[name=pseudo_random_function]').val(preset.attr('pseudo-random-function')).trigger('change');
        });


    }
    validation(){
        const thisClass = this;
        let form = document.getElementById('frm-generalForms-editBranchForm-branchForm');
        if(form){
            let formContainer = $(form);
            let submitButtonID = formContainer.find('button[type=submit]')[0].attributes.id.value;
            let submitButton = document.getElementById(submitButtonID);
            let deleteButton = document.getElementById('edit_branch_form_delete');

            this.fv = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'BranchName': {
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                },
                                stringLength: {
                                    max: 64,
                                    message: 'Name cannot be over 64 characters',
                                },
                                regexp: {
                                    regexp: /^[a-zA-ZáčďéěíňóřšťůúýžÁČĎÉĚÍŇÓŘŠŤŮÚÝŽ0-9' _.-]*$/,
                                    message: 'Only these special characters are allowed. (_.-)',
                                },
                                remote: {
                                    enabled: false,
                                    method: 'POST',
                                    url: '/branches/?do=checkUnique',
                                    message: 'This name is already taken.',
                                    data: function () {
                                        return {
                                            organizationId: new URLSearchParams(window.location.search).get('organizationID'),
                                            branchID: thisClass.branchID
                                        };
                                    },
                                }
                            }
                        },
                        'BranchSubnet':  {
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                },
                                stringLength: {
                                    max: 64,
                                    message: 'Branch subnet cannot be over 64 characters',
                                },
                                regexp: {
                                    regexp: /^((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(((\/([4-9]|[12][0-9]|3[0-2]))?)|\s?-\s?((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))))$/,
                                    message: 'You have entered an invalid subnet',
                                },
                                remote: {
                                    enabled: false,
                                    method: 'POST',
                                    url: '/branches/?do=checkCollision',
                                    data: function () {
                                        return {
                                            organizationId: new URLSearchParams(window.location.search).get('organizationID'),
                                            branchID: thisClass.branchID
                                        };
                                    },
                                }
                            }
                        },
                        'shared_secret':{
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                },
                                regexp: {
                                    regexp: /^[a-zA-ZáčďéěíňóřšťůúýžÁČĎÉĚÍŇÓŘŠŤŮÚÝŽ0-9' _.-]*$/,
                                    message: 'Only letters, numbers and special characters _.- are allowed',
                                },
                            }
                        },
                        'public_ip':{
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                },
                                regexp: {
                                    regexp: /^(?!^0\.)(?!^10\.)(?!^100\.6[4-9]\.)(?!^100\.[7-9]\d\.)(?!^100\.1[0-1]\d\.)(?!^100\.12[0-7]\.)(?!^127\.)(?!^169\.254\.)(?!^172\.1[6-9]\.)(?!^172\.2[0-9]\.)(?!^172\.3[0-1]\.)(?!^192\.0\.0\.)(?!^192\.0\.2\.)(?!^192\.88\.99\.)(?!^192\.168\.)(?!^198\.1[8-9]\.)(?!^198\.51\.100\.)(?!^203.0\.113\.)(?!^22[4-9]\.)(?!^23[0-9]\.)(?!^24[0-9]\.)(?!^25[0-5]\.)(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))|(0\.0\.0\.0\/0)$/,
                                    message: 'Only Public IP is allowed',
                                },
                            }
                        },
                        'tunnel_lifetime':{
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                },
                                integer: {
                                    message: 'Value must be a number',
                                },
                                between: {
                                    min: 1,
                                    max: 24,
                                    message: 'Tunnel life time can be in range from 1 to 20'
                                }
                            }
                        },
                        'ike_lifetime':{
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                },
                                integer: {
                                    message: 'Value must be a number',
                                },
                                between: {
                                    min: 1,
                                    max: 24,
                                    message: 'IKE lifetime can be in range from 1 to 24'
                                }
                            }
                        },
                        'dpdd':{
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                },
                                integer: {
                                    message: 'Value must be a number',
                                },
                                between: {
                                    min: 1,
                                    max: 100,
                                    message: 'Dead Peer Detection Delay can be in range from 1 to 100.'
                                }
                            }
                        },
                        'encryption_phase_1':{
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                }
                            }
                        },
                        'encryption_phase_2':{
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                }
                            }
                        },
                        'integrity_phase_1':{
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                }
                            }
                        },
                        'integrity_phase_2':{
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                }
                            }
                        },
                        'dh_phase_1':{
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                }
                            }
                        },
                        'dh_phase_2':{
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                }
                            }
                        },
                        'remote_id':{
                            validators: {
                                regexp: {
                                    regexp: /^[a-zA-ZáčďéěíňóřšťůúýžÁČĎÉĚÍŇÓŘŠŤŮÚÝŽ0-9' _.-]*$/,
                                    message: 'Only these special characters are allowed. (_.-)',
                                },
                            }
                        },
                        'snat':{
                            validators: {
                                regexp: {
                                    regexp: /^(10\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])|172\.(?:1[6-9]|2[0-9]|3[0-1])\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])|192\.168\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))$/,
                                    message: 'Only private IP is allowed',
                                },
                            }
                        }
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            delay: {
                                BranchSubnet: 0.5,
                                BranchName: 0.5
                            },
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.form-validation-marker',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                    }
                }
            ).on('core.element.validated', function(e) {
                if(e.element.classList.contains('d-none') || e.element.classList.contains('form-select')){
                    // Get the icon plugin instance
                    const iconPlugin = validator.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element) ? iconPlugin.icons.get(e.element) : null;
                    // Hide the icon
                    iconElement && (iconElement.style.display = 'none');
                }
            }).on('core.form.validating', function(event) {
                new DismissModal('edit_branch_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
                if(deleteButton){
                    deleteButton.disabled = true;
                }
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('edit_branch_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
                if(deleteButton){
                    deleteButton.disabled = false;
                }
            });
            const fv = this.fv;
            this.fv.on('core.element.notvalidated', function(e) {
                if(e.field === 'dpdd' || e.field === 'ike_lifetime' || e.field === 'tunnel_lifetime'){
                    const iconPlugin = fv.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element)
                        ? iconPlugin.icons.get(e.element)
                        : null;

                    iconElement && (iconElement.style.display = 'none');
                }
            });
        }
        this.addExtraFieldValidation();
    }
    addExtraFieldValidation(){
        const constFv = this.fv;
        if($('#edit-branch-ipsec').is(':checked')){
            constFv.enableValidator('shared_secret');
            constFv.enableValidator('public_ip');
            constFv.enableValidator('tunnel_lifetime');
            constFv.enableValidator('ike_lifetime');
            constFv.enableValidator('dpdd');
            constFv.enableValidator('encryption_phase_1');
            constFv.enableValidator('encryption_phase_2');
            constFv.enableValidator('integrity_phase_1');
            constFv.enableValidator('integrity_phase_2');
            constFv.enableValidator('dh_phase_1');
            constFv.enableValidator('dh_phase_2');
        }
    }
}
window.EditBranchForm = EditBranchForm;